import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { User } from '../../../models/users/user';
import { UserTableViewComponent } from '../user-table-view/user-table-view.component';
import { TableView } from '../../ui/filterable-table/tableView';
import { UserService } from '../../../models/users/userService';

@Component({
  selector: 'app-edit-user-group',
  templateUrl: './edit-user-group.component.html',
  standalone: false,
})
export class EditUserGroupComponent implements OnChanges {
  @Input() groupName: string | undefined;
  @Output() cancelled: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('userTable2') userTableControl: UserTableViewComponent | undefined;

  tableView: any;
  tableViewOptions: any = {
    isAdmin: true,
  };

  users: Partial<User>[] = [];

  constructor(private userService: UserService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['groupName'] && changes['groupName'].currentValue) {
      this.groupName = changes['groupName'].currentValue;

      if (this.groupName) {
        this.userService.getUserGroupUsers(this.groupName).then((users) => {
          this.users = users;
          this.userTableControl?.setOptions(this.tableViewOptions);
        });
      }
    }
  }

  ngOnInit() {
    this.tableView = new TableView(UserTableViewComponent);
    this.tableViewOptions.allowEditing = false;
    this.tableViewOptions.allowImpersonation = false;
  }

  handleUserSelected(user: User) {
    if (this.groupName) {
      let gname = this.groupName;

      this.userService.addUserToGroup(user.id, gname).then(() => {
        this.userService.getUserGroupUsers(gname).then((users) => {
          this.users = users;
        });
      });
    }
  }

  handleCancelled() {
    this.cancelled.emit();
  }

  btnCancel_click() {
    this.handleCancelled();
  }

  btnBack_click() {
    this.handleCancelled();
  }

  btnRemoveUser_click(user: Partial<User>) {
    if (this.groupName) {
      let gname = this.groupName;

      if (user && user.id) {
        this.userService.removeUserFromGroup(user.id, gname).then(() => {
          this.userService.getUserGroupUsers(gname).then((users) => {
            this.users = users;
          });
        });
      }
    }
  }
}
